import { Stack } from "@mantine/core";
import { Button, Text, Title } from "../components-ui";
import { useNavigate } from "react-router-dom";
import { Home } from "tabler-icons-react";

export default function NotFoundPage() {
  let navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <Stack
      align="center"
      justify="center"
      spacing="xl"
      style={{
        minHeight: 600,
      }}
    >
      <Title order={1} testid="404-not-found">
        404 Not Found
      </Title>
      <Text size="md" testid="404-sorry">
        Sorry, we couldn't find the page you were looking for.
      </Text>
      <Button leftIcon={<Home />} onClick={goHome} testid="404-go-home">
        Go Home
      </Button>
    </Stack>
  );
}
